<template>
  <b-col lg="12">
    <b-overlay :show="show" rounded="sm">
      <modal-adicionar-itens ref="adicionar-itens-pedido" />
      <modal-editar-itens ref="editar-itens-pedido" />
      <!-- <modal_pic_pedido ref="open_modal_pic" /> -->
      <b-col>
        <div class="demo-inline-spacing">
          <b-button class="mr-2 bg-secondary bg-darken-2 border-0" @click="voltar">
            <feather-icon icon="ArrowLeftCircleIcon" size="18" />
            Voltar
          </b-button>
          <b-button class="mr-2 bg-success bg-darken-2 border-0"
            :disabled="getListTabelaItens.length === 0 || !pedidoMinimo" @click="confirmarSalvar">
            <feather-icon icon="SaveIcon" size="18" />
            Salvar
          </b-button>
          <b-button class="mr-2 bg-darken-2 border-0" variant="outline-secondary"
            :disabled="getListTabelaItens.length === 0 || !pedidoMinimo" @click="confirmarRascunho">
            <feather-icon icon="FileTextIcon" size="18" />
            Rascunho
          </b-button>
          <!-- <b-button v-if="!isClienteFinal" class="mr-2 bg-danger bg-darken-2 border-0" @click="limparFormulario">
            <feather-icon icon="TrashIcon" size="18" />
            Limpar
          </b-button> -->
        </div>
      </b-col>
      <b-col md="12" class="mt-2">
        <b-card no-body>
          <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
            <b-card-title>Pedido</b-card-title>
          </b-card-header>
          <b-tabs card pills nav-class="nav-pill-primary">
            <b-tab>
              <template #title>
                <feather-icon icon="PocketIcon" />
                <span>Condições</span>
              </template>
              <!-- <b-alert v-if="isInfoPedidoBloqueado" show variant="warning" class="mb-3">
                <feather-icon icon="AlertTriangleIcon" class="mr-1" />
                <span>O pedido possui itens adicionados. Remova todos os itens para alterar as informações.</span>
              </b-alert> -->
              <h5 class="mb-2">
                NR Pré-Pedido
              </h5>
              <info-pedido :bloqueado="isInfoPedidoBloqueado" />
            </b-tab>
            <b-tab :disabled="isTabItensDisabled">
              <template #title>
                <feather-icon icon="ListIcon" />
                <span>Itens</span>
              </template>
              <b-alert variant="warning" :show="!pedidoMinimo && getListTabelaItens.length > 0">
                <div class="alert-body">
                  <feather-icon icon="AlertTriangleIcon" class="mr-50" />
                  <span>Pedido mínimo: R${{ dadosCliente.valorMinimoPedido }}</span>
                </div>
              </b-alert>
              <b-alert variant="info" :show="getListTabelaItens.length > 0">
                <div class="alert-body">
                  <feather-icon icon="InfoIcon" class="mr-50" />
                  <span>Valor total do pedido: R${{ getTotalPedido.toFixed(2) }}</span>
                </div>
              </b-alert>
              <b-col>
                <div class="demo-inline-spacing">
                  <b-button variant="success" @click="openModal">
                    <feather-icon icon="PlusIcon" size="18" />
                    Novo
                  </b-button>
                </div>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
              <b-table :items="getListTabelaItens" :fields="fields" striped responsive :striped="true" :bordered="true"
                :hover="true" v-if="getListTabelaItens.length != 0">
                <template #cell(PrecoUnitario)="row">
                  {{ row.item.PrecoUnitario | formtPriceBr }}
                </template>
                <template #cell(ValorTotal)="row">
                  {{ row.item.ValorTotal | formtPriceBr }}
                </template>
                <template #cell(precoComImposto)="row">
                  {{ row.item.itens[0].precoComImposto | formtPriceBr }}
                </template>
                <template #cell(valorTotalComImposto)="row">
                  {{row.item.itens.reduce((acc, item) => acc + item.valorTotalComImposto, 0) | formtPriceBr}}
                </template>

                <template #cell(mostrar_detalhes)="row">
                  <b-form-checkbox v-model="row.detailsShowing" plain class="vs-checkbox-con"
                    @change="row.toggleDetails">
                    <span class="vs-checkbox">
                      <span class="vs-checkbox--check">
                        <i class="vs-icon feather icon-check" />
                      </span>
                    </span>
                    <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                  </b-form-checkbox>
                </template>

                <template #row-details="row">
                  <b-card>
                    <b-table responsive="sm" :fields="fieldsSub" :items="row.item.itens" :striped="true"
                      :bordered="true" :hover="true" table-variant="outline-secondary">
                      <template #cell(precoUnitario)="row">
                        {{ row.item.precoUnitario | formtPriceBr }}
                      </template>
                      <template #cell(precoComImposto)="row">
                        {{ row.item.precoComImposto | formtPriceBr }}
                      </template>
                      <template #cell(pedidoItemQuantidade)="subRow">
                        <div class="d-flex align-items-center justify-content-center">
                          <b-button size="sm" variant="outline-danger" class="mr-1"
                            @click="decrementQuantity({ index: row.index, item: row.item }, { index: subRow.index, item: subRow.item })"
                            :disabled="subRow.item.pedidoItemQuantidade <= (subRow.item.itemMultiplo || 1) || !isValidDecrement(subRow)"
                            v-b-tooltip.hover :title="getMultiploTooltip(subRow)">
                            <feather-icon icon="MinusIcon" size="14" />
                          </b-button>
                          <b-form-input
                            v-model.number="subRow.item.pedidoItemQuantidade"
                            type="number"
                            :min="subRow.item.itemMultiplo || 1"
                            :step="subRow.item.itemMultiplo || 1"
                            @input="handleQuantityDirectInput({ index: row.index, item: row.item }, { index: subRow.index, item: subRow.item }, $event)"
                            @blur="validateQuantityOnBlur({ index: row.index, item: row.item }, { index: subRow.index, item: subRow.item })"
                            @keydown="preventInvalidInput"
                            class="mx-1 text-center"
                            style="width: 70px; padding: 2px 5px;"
                          />
                          <b-button size="sm" variant="outline-success" class="ml-1"
                            @click="incrementQuantity({ index: row.index, item: row.item }, { index: subRow.index, item: subRow.item })"
                            :disabled="!isValidIncrement(subRow)" v-b-tooltip.hover :title="getMultiploTooltip(subRow)">
                            <feather-icon icon="PlusIcon" size="14" />
                          </b-button>
                        </div>
                      </template>
                      <template #cell(valorTotal)="row">
                        {{ row.item.valorTotal | formtPriceBr }}
                      </template>
                      <template #cell(valorTotalComImposto)="row">
                        {{ row.item.valorTotalComImposto | formtPriceBr }}
                      </template>
                      <template #cell(excluir)="subRow">
                        <b-button size="sm" variant="outline-danger" @click="removeSubItem(row, subRow.index)">
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </template>
                    </b-table>
                    <b-button size="sm" variant="outline-secondary" @click="row.toggleDetails">
                      Ocultar Detalhes
                    </b-button>
                  </b-card>
                </template>
                <template #cell(promo)="row">
                  <b-badge :variant="row.item.tipoPedido === 'pic' ? 'light-success' : 'light-primary'">
                    {{ row.item.tipoPedido === 'pic' ? 'Promoção' : 'Normal' }}
                    <feather-icon icon="TagIcon" v-if="row.item.tipoPedido === 'pic'" />
                  </b-badge>
                </template>

                <template #cell(editar)="row">
                  <b-button size="sm" class="mr-2 bg-primary bg-darken-2 border-0"
                    @click="editarItem({ index: row.index, item: row.item })">
                    <feather-icon icon="EditIcon" class="rotate-icon" />
                  </b-button>
                </template>

                <template #cell(excluir)="data">
                  <b-button size="sm" class="mr-2 bg-danger bg-darken-5 border-0" @click="removeItem(data)">
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </template>
              </b-table>
            </b-tab>
            <b-tab>
              <template #title>
                <feather-icon icon="TruckIcon" />
                <span>Entrega</span>
              </template>
              <b-row>
                <b-col md="2">
                  <b-form-group label="Data Estimada Entrega">
                    <b-form-input type="date" placeholder=""
                      :value="dataEntregaPadrao"
                      :min="todayISO" @input="handleDateChange($event)" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Endereço">
                    <b-form-input type="text" placeholder="" v-model="formInfoPedido.enderecoEntrega.clienteendereco"
                      disabled />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="CEP">
                    <b-form-input type="number" placeholder=""
                      v-model="formInfoPedido.enderecoEntrega.clienteenderecocep" disabled />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Bairro">
                    <b-form-input type="text" placeholder=""
                      v-model="formInfoPedido.enderecoEntrega.clienteenderecobairro" disabled />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Cidade">
                    <b-form-input type="text" placeholder=""
                      v-model="formInfoPedido.enderecoEntrega.clienteenderecocidade" disabled />
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="Estado">
                    <b-form-input type="text" placeholder="" v-model="formInfoPedido.enderecoEntrega.ufid" disabled />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-overlay>
  </b-col>
</template>

<script>
import {
  BTabs,
  BTab,
  BCardText,
  BCard,
  BCol,
  BCardHeader,
  BFormSelect,
  BFormInput,
  BRow,
  BSpinner,
  BFormGroup, BButton, BTable, BFormCheckbox, BCardFooter,
} from 'bootstrap-vue';
import { required } from '@core/utils/validations/validations';
import { mapActions, mapGetters } from 'vuex';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ModalAdicionarItens from '@/views/app/operacoes/pedidosVendas/modal/modalAdicionarItens.vue';
import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
import SLSEsPrioriService from '@/services/SistemaDKP/SLSEsPriori.service';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import Swal from 'sweetalert2';
import { formtPriceBr } from '@core/utils/filter';
import SLSPedidosService from '@/services/Operacoes/SLSPedidos.service';
import SLSTabelaPrecoService from '@/services/SistemaDKP/SLSTabelapreco.service';
import modal_pic_pedido from '@/components/modal/modal_pic_pedido.vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import InfoPedido from '@/components/catalogo-produtos/InfoPedido.vue';
import SLSPicService from '@/services/Operacoes/SLSPic.service';
import ModalEditarItens from '@/views/app/operacoes/pedidosVendas/modal/modalEditarItens.vue';
import { getParametro } from '@/utils/totvsApi';

const slsRepresentanteService = new SLSRepresentanteService();
const slsClienteService = new SLSClienteService();
const slsEsPrioriService = new SLSEsPrioriService();
const slsPedidosService = new SLSPedidosService();
const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const slsTabelapreco = new SLSTabelaPrecoService();

const picService = new SLSPicService();
export default {
  components: {
    ModalEditarItens,
    modal_pic_pedido,
    ModalAdicionarItens,
    BCardFooter,
    BButton,
    BFormGroup,
    BRow,
    BFormInput,
    BFormSelect,
    BCardHeader,
    BCol,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BSpinner,
    BTable,
    BFormCheckbox,
    AppCollapse,
    AppCollapseItem,
    InfoPedido,
  },
  filters: {
    formtPriceBr,
  },
  data: () => ({
    collapseType: 'border',
    selected: null,
    required,
    show: false,
    representantesCount: 0,
    clientesCount: 0,
    isLoadingPromocoes: false,
    dadosCliente: {},
    todayISO: new Date().toISOString().split('T')[0],
    fields: ['mostrar_detalhes',
      { key: 'DescricaoMarca', label: 'Marca', sortable: true },
      { key: 'DescricaoReferencia', label: 'Referência', sortable: true },
      { key: 'sequencia', label: 'Sequência', sortable: true },
      { key: 'Qtde', label: 'Quantidade', sortable: true },
      // {key: 'PrecoUnitario', label: 'Valor Unitario', sortable: true},
      // {key: 'ValorTotal', label: 'Valor Total', sortable: true},
      { key: 'precoComImposto', label: 'Preço Unitario Final', sortable: true },
      { key: 'valorTotalComImposto', label: 'Valor Total Final', sortable: true },
      { key: 'promo', label: 'Tipo Pedido', sortable: true },
      // {key: 'editar', label: 'Editar', sortable: true},
      { key: 'excluir', label: 'Excluir', sortable: true },
    ],
    fieldsSub: [
      { key: 'itemId', label: 'Código', sortable: true },
      { key: 'item_descricao', label: 'Descrição', sortable: true },
      { key: 'marca', label: 'Marca', sortable: true },
      { key: 'des_cor', label: 'Cor', sortable: true },
      { key: 'embalagem', label: 'Embalagem', sortable: true },
      { key: 'pedidoItemQuantidade', label: 'QTD', sortable: true },
      // {key: 'precoUnitario', label: 'Valor Unitario', sortable: true},
      { key: 'precoComImposto', label: 'Valor Unitário Final', sortable: true },
      // {key: 'valorTotal', label: 'Valor Total', sortable: true},
      { key: 'valorTotalComImposto', label: 'Valor Total Final', sortable: true },
      { key: 'pedidoItemQuantidadeSaldo', label: 'QTD Saldo', sortable: true },
      { key: 'pedidoItemQuantidadeFaturada', label: 'QTD Faturado', sortable: true },
      { key: 'excluir', label: 'Excluir', sortable: false },
    ],
  }),
  beforeDestroy() {
    this.$root.$off('condpagto:selected');

    // Código de limpeza aqui
    // console.log('Componente está prestes a ser desmontado');

    // LIMPAR PROMOÇÕES
    this.$store.commit('PicStore/SET_PIC', {
      pic_genericas: [],
      pic_cliente: [],
    });
  },
  methods: {
    ...mapActions('intensPedido', [
      'removeItemListTabelaItens',
      'clearCreatePedido',
      'exibirItemEditar',
    ]),
    async confirmarSalvar() {
      const result = await Swal.fire({
        title: 'Confirmar Pedido',
        text: 'Tem certeza que deseja finalizar este pedido?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, finalizar pedido',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        await this.onSubmit();
      }
    },
    async confirmarRascunho() {
      const result = await Swal.fire({
        title: 'Salvar como Rascunho',
        text: 'O pedido será salvo como rascunho e poderá ser editado posteriormente.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#17a2b8',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, salvar rascunho',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        await this.onSubmitRascunho();
      }
    },
    // getFormattedDateForInput(dateString) {
    //   if (!dateString) {
    //     return this.getDefaultDate();
    //   }

    //   if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    //     return dateString;
    //   }

    //   if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    //     const parts = dateString.split('/');
    //     return `${parts[2]}-${parts[1]}-${parts[0]}`;
    //   }

    //   return dateString;
    // },
    // getDefaultDate() {
    //   const date = new Date();
    //   date.setDate(date.getDate() + 15);

    //   const year = date.getFullYear();
    //   const month = String(date.getMonth() + 1).padStart(2, '0');
    //   const day = String(date.getDate()).padStart(2, '0');

    //   return `${year}-${month}-${day}`;
    // },
    handleDateChange(event) {
      if (!event) return;

      const isoDate = event;
      const parts = isoDate.split('-');
      const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;

      this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
        ...this.formInfoPedido.enderecoEntrega,
        dataPrevistaEntrega: formattedDate,
      });

      const infoFormData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      if (infoFormData && infoFormData.enderecoEntrega) {
        const merged = {
          ...infoFormData,
          enderecoEntrega: {
            ...infoFormData.enderecoEntrega,
            dataPrevistaEntrega: formattedDate,
          },
        };
        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', merged);
      }

      console.log('Data atualizada para:', formattedDate);
    },
    calcularDataEntregaPadrao() {
      const hoje = new Date();
      const diasUteis = 5;

      const dataEntrega = new Date(hoje);
      let diasAdicionados = 0;

      while (diasAdicionados < diasUteis) {
        dataEntrega.setDate(dataEntrega.getDate() + 1);
        const diaDaSemana = dataEntrega.getDay();
        if (diaDaSemana !== 0 && diaDaSemana !== 6) {
          diasAdicionados++;
        }
      }

      return dataEntrega.toISOString().split('T')[0];
    },
    preventInvalidInput(event) {
      if (event.key === '0' && event.target.value === '') {
        event.preventDefault();
      }
      if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
        event.preventDefault();
      }
    },
    async handleQuantityDirectInput(row, subRow, event) {
      let newQuantity = parseInt(event) || 1;
      const itemMultiplo = parseInt(subRow.item.itemMultiplo || 1);
      const minQuantity = itemMultiplo > 1 ? itemMultiplo : 1;

      if (newQuantity < minQuantity || isNaN(newQuantity) || newQuantity === 0) {
        newQuantity = minQuantity;
      }

      if (itemMultiplo > 1 && newQuantity % itemMultiplo !== 0) {
        newQuantity = Math.ceil(newQuantity / itemMultiplo) * itemMultiplo;
      }

      subRow.item.pedidoItemQuantidade = newQuantity;
      await this.handleQuantityChange(row, subRow);
    },
    validateQuantityOnBlur(row, subRow) {
      const itemMultiplo = parseInt(subRow.item.itemMultiplo || 1);
      const minQuantity = itemMultiplo > 1 ? itemMultiplo : 1;

      if (!subRow.item.pedidoItemQuantidade || subRow.item.pedidoItemQuantidade < minQuantity) {
        subRow.item.pedidoItemQuantidade = minQuantity;
        this.handleQuantityDirectInput(row, subRow, minQuantity);
      }
    },
    async incrementQuantity(row, subRow) {
      console.log('Incrementando quantidade para:', { rowIndex: row.index, subRowIndex: subRow.index });

      const itemMultiplo = subRow.item.itemMultiplo || 1;
      if (itemMultiplo > 1) {
        subRow.item.pedidoItemQuantidade += itemMultiplo;
      } else {
        subRow.item.pedidoItemQuantidade += 1;
      }

      await this.handleQuantityChange(row, subRow);
    },
    async decrementQuantity(row, subRow) {
      console.log('Decrementando quantidade para:', { rowIndex: row.index, subRowIndex: subRow.index });

      const itemMultiplo = subRow.item.itemMultiplo || 1;
      const minQuantity = itemMultiplo > 1 ? itemMultiplo : 1;

      if (subRow.item.pedidoItemQuantidade > minQuantity) {
        if (itemMultiplo > 1) {
          subRow.item.pedidoItemQuantidade -= itemMultiplo;
        } else {
          subRow.item.pedidoItemQuantidade -= 1;
        }
        await this.handleQuantityChange(row, subRow);
      }
    },
    isValidIncrement(subRow) {
      const itemMultiplo = subRow.item.itemMultiplo || 1;
      if (itemMultiplo <= 1) return true;

      const newQuantity = subRow.item.pedidoItemQuantidade + 1;
      return newQuantity % itemMultiplo === 0;
    },
    isValidDecrement(subRow) {
      const itemMultiplo = subRow.item.itemMultiplo || 1;
      if (itemMultiplo <= 1) return true;

      const newQuantity = subRow.item.pedidoItemQuantidade - 1;
      if (newQuantity < itemMultiplo) return false;
      return newQuantity % itemMultiplo === 0;
    },
    getMultiploTooltip(subRow) {
      const itemMultiplo = subRow.item.itemMultiplo || 1;
      if (itemMultiplo <= 1) return '';
      return 'Não é possível alterar a quantidade de um item múltiplo.';
    },
    async handleQuantityChange(row, subRow) {
      if (!row || row.index === undefined || !subRow || subRow.index === undefined) {
        console.error('Índices inválidos:', { row, subRow });
        return;
      }

      const newQuantity = parseInt(subRow.item.pedidoItemQuantidade);
      const item = { ...row.item };
      const subItem = { ...subRow.item };

      if (!item || !subItem) {
        console.error('Item ou subItem não encontrado:', { row, subRow });
        return;
      }

      console.log('Valores antes da atualização:', {
        quantidade: subItem.pedidoItemQuantidade,
        precoUnitario: subItem.precoUnitario,
        precoComImposto: subItem.precoComImposto,
        valorTotalAtual: subItem.valorTotal,
        valorTotalComImpostoAtual: subItem.valorTotalComImposto,
      });

      const precoComImposto = parseFloat(subItem.precoComImposto || subItem.precoUnitario);

      subItem.valorTotal = parseFloat(subItem.precoUnitario) * newQuantity;
      subItem.valorTotalComImposto = precoComImposto * newQuantity;

      console.log('Novos valores calculados para o subitem:', {
        quantidade: newQuantity,
        valorTotal: subItem.valorTotal,
        valorTotalComImposto: subItem.valorTotalComImposto,
      });

      const updatedItens = [...item.itens];
      updatedItens[subRow.index] = subItem;

      const valorTotalComImpostos = updatedItens.reduce(
        (sum, si) => sum + parseFloat(si.valorTotalComImposto || si.valorTotal || 0), 0,
      );

      const updatedItem = {
        ...item,
        itens: updatedItens,
        Qtde: updatedItens.reduce((sum, si) => sum + parseInt(si.pedidoItemQuantidade || 0), 0),
        ValorTotal: updatedItens.reduce((sum, si) => sum + parseFloat(si.valorTotal || 0), 0),
        ValorTotalComImposto: valorTotalComImpostos,
      };

      console.log('Item atualizado:', {
        Qtde: updatedItem.Qtde,
        ValorTotal: updatedItem.ValorTotal,
        ValorTotalComImposto: updatedItem.ValorTotalComImposto,
        itensLength: updatedItem.itens.length,
      });

      try {
        this.$store.commit('intensPedido/UPDATE_TABELA_ITEM', {
          index: row.index,
          item: updatedItem,
        });

        const totalAtual = this.$store.getters['intensPedido/getTotalPedido'];
        const valorMinimo = parseFloat(this.dadosCliente.valorMinimoPedido || 0);

        // console.log('Total com impostos recalculado após atualização:', {
        //   totalAtual,
        //   valorMinimo,
        //   pedidoMinimo: totalAtual >= valorMinimo,
        // });
      } catch (error) {
        console.error('Erro ao atualizar quantidade:', error);
        subRow.item.pedidoItemQuantidade = newQuantity - 1;
      }
    },
    removeLeadingZeros(value) {
      if (!value) return '';
      return String(value).replace(/^0+/, '');
    },
    // limparFormulario() {
    //   this.$bvModal.msgBoxConfirm('Tem certeza que deseja limpar todos os campos do formulário?', {
    //     title: 'Confirmar limpeza',
    //     size: 'sm',
    //     buttonSize: 'sm',
    //     okVariant: 'danger',
    //     okTitle: 'Sim, limpar',
    //     cancelTitle: 'Cancelar',
    //     footerClass: 'p-2',
    //     hideHeaderClose: false,
    //     centered: true
    //   })
    //     .then(value => {
    //       if (value) {
    //         const representanteData = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"].representante;
    //         this.clearCreatePedido();
    //         this.$store.commit('PicStore/RESET_PIC_SELECTION');

    //         if (representanteData && representanteData.representanteid) {
    //           this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', representanteData);
    //           this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representanteData);
    //           this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
    //           this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
    //             representanteid: representanteData.representanteid,
    //             representantenome: representanteData.representantenome,
    //           });
    //         }

    //         if (this.$store.getters['auth/IS_LOGGED_IN']) {
    //           const userId = this.getUserId();
    //           if (representanteData && representanteData.representanteid) {
    //             const formData = {
    //               ...this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"],
    //               representante: representanteData
    //             };
    //             localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(formData));
    //           } else {
    //             localStorage.removeItem(`infoPedidoForm_${userId}`);
    //           }
    //         }

    //         this.$toast({
    //           component: ToastificationContent,
    //           props: {
    //             title: 'Formulário limpo',
    //             text: 'Todos os campos foram limpos com sucesso.',
    //             icon: 'CheckIcon',
    //             variant: 'success',
    //           },
    //         });
    //       }
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    getUserId() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'));
        return userData?.id || 'default';
      } catch (error) {
        console.error('Erro ao obter ID do usuário:', error);
        return 'default';
      }
    },
    handleCondPagtoKeydown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onChangeCondPagto(event);
      }
    },
    verificarPerfilUsuario() {
      try {
        const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
        const isClienteFinal = perfilLogado && (perfilLogado.perfil_acesso_nome === 'ClienteFinal'
          || perfilLogado.perfil_acesso_nome === 'Representante'
          || perfilLogado.perfil_acesso_nome === 'Supervisor');
        if (isClienteFinal) {
          this.contarRepresentantesEClientes();
        }
      } catch (error) {
        console.error('Erro ao verificar perfil do usuário:', error);
      }
    },
    async contarRepresentantesEClientes() {
      try {
        await this.$store.dispatch('SLSRepresentante/resertFilters');
        const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();
        this.representantesCount = representantes ? representantes.length : 0;

        if (this.representantesCount === 1 && representantes[0]) {
          this.formInfoPedido.dataCapaPedido.representanteid = representantes[0].representanteid;
          this.formInfoPedido.dataCapaPedido.representantenome = representantes[0].representantenome;
          this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representantes[0]);

          const representanteId = representantes[0].representanteid;

          await this.$store.commit('SLSCliente/SET_FILTERS', {
            page: 1,
            perPage: 100,
            representanteid: representanteId,
          });

          const clientes = await slsClienteService.listarClienteInfoPedido({ representanteid: representanteId });
          this.clientesCount = clientes ? clientes.length : 0;

          if (this.clientesCount === 1 && clientes[0]) {
            await this.onChagenClienteAuto(clientes[0]);
          }
        }
      } catch (error) {
        console.error('Erro ao contar representantes e clientes:', error);
      }
    },
    async onChagenClienteAuto(cliente) {
      if (!cliente) return;

      this.formInfoPedido.dataCapaPedido.clienteiderp = cliente.clienteiderp;
      await this.onChagenCliente();
    },
    async onChangeCondPagto(event) {
      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      const codigoCondPagto = typeof event === 'object' && event.target
        ? event.target.value
        : this.formInfoPedido.dataCapaPedido.condicaopagamentoid;

      if (!codigoCondPagto || !codigoCondPagto.length) {
        this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
        return;
      }

      this.$store.commit('intensPedido/SET_IS_LOADING', true);

      try {
        const clienteId = this.formInfoPedido.dataCapaPedido.clienteid
          || this.formInfoPedido.enderecoEntrega?.clienteid;

        if (!clienteId) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não selecionado',
              text: 'Selecione um cliente antes de definir a condição de pagamento.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
          return;
        }

        const condPagamentos = await slsCondicaoPagamentoService.GetCondPagtoByClienteId(clienteId);

        if (!Array.isArray(condPagamentos) || condPagamentos.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sem condições de pagamento',
              text: 'Não foram encontradas condições de pagamento para este cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
          return;
        }

        const existCondPagto = condPagamentos.find(
          (cond) => String(cond.condicaopagamentoid) === String(codigoCondPagto),
        );

        if (existCondPagto) {
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = existCondPagto.condicaopagamentodescricao;
          this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', existCondPagto.condicaopagamentoid);
          await picService.getPicPedidos();
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Condição não encontrada',
              text: 'Não foi encontrada condição de pagamento com este código para o cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
          this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
        }
      } catch (error) {
        console.error('Erro ao buscar condição de pagamento:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao buscar condição de pagamento. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
        this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
      } finally {
        this.$store.commit('intensPedido/SET_IS_LOADING', false);
      }
    },
    async openModal() {
      const info = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      this.$store.commit('intensPedido/SET_FORM_DATA', {
        dataCapaPedido: {
          tabelaprecoid: info?.tabelaPreco?.tabelapreco_id,
          clienteiderp: info?.cliente?.clienteiderp,
          estabelecimentoid: info?.estabelecimento?.estabelecimentoid,
          representanteid: info?.representante?.representanteid,
        },
      });
      await this.$refs['adicionar-itens-pedido'].show('novo', null);
    },
    async openModalPic() {
      const operacaoData = {
        estabelecimento: {
          estabelecimentoid: this.formInfoPedido.dataCapaPedido.estabelecimentoid,
        },
        cliente: {
          clientenomeabreviado: this.formInfoPedido.dataCapaPedido.clientenomeabreviado,
        },
        naturezaOperacao: {
          naturezaoperacaoid: this.formInfoPedido.dataCapaPedido.naturezaoperacaoid,
        },
        canalVenda: {
          canal_venda_id: this.formInfoPedido.dataCapaPedido.canalvendaid,
        },
        enderecoEntrega: {
          ufid: this.formInfoPedido.enderecoEntrega.ufid,
          clienteenderecocidade: this.formInfoPedido.enderecoEntrega.clienteenderecocidade,
        },
        clienteisentoie: this.formInfoPedido.dataCapaPedido.clienteisentoie,
        tabelaprecoid: this.formInfoPedido.dataCapaPedido.tabelaprecoid,
        condicaopagamentoid: this.formInfoPedido.dataCapaPedido.condicaopagamentoid,
      };

      this.$root.$emit('openModal:pic', {
        type: 'operacao-pedido',
        operacao: 'create',
        data: operacaoData,
      });
    },
    async loadingRepresentantes() {
      // const representantes = this.$store.getters['SLSRepresentante/representantes'];
      // if (representantes && representantes.length > 0) {
      //   console.log('Representantes já carregados, usando cache');
      //   return;
      // }

      await this.$store.dispatch('SLSRepresentante/resertFilters');
      this.$store.commit('SLSRepresentante/SET_FILTERS_PER_PAGE', 10);
      await slsRepresentanteService.listarRepresentanteInfoPedido();
    },
    async onChageCodigoRepresentante() {
      this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', true);

      await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');

      this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
        ...this.formInfoPedido.dataCapaPedido,
        clienteiderp: '',
        cliente_nome: '',
        clientenomeabreviado: '',
        clienteisentoie: '',
        condicaopagamentoid: '',
        condicaopagamentodescricao: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        naturezaoperacaoid: '',
        naturezaoperacaodescricao: '',
        canalvendaid: '',
        canal_venda_descricao: '',
        estabelecimentoid: '',
        estabelecimentorazaosocial: '',
      });

      this.$store.commit('InfoPedido/SET_OPTIONS_TABELA_PRECO', []);
      this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', []);
      this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', []);

      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      if (!this.formInfoPedido.dataCapaPedido.representanteid) {
        await this.$store.dispatch('intensPedido/resetDataCapaPedido');
        this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
        return;
      }

      try {
        await this.$store.dispatch('SLSRepresentante/resertFilters');
        this.$store.commit('SLSRepresentante/SET_FILTERS_REPRESENTANTE_ID', this.formInfoPedido.dataCapaPedido.representanteid);
        this.$store.commit('SLSRepresentante/SET_FILTERS_PER_PAGE', 10);

        const response = await slsRepresentanteService.listarRepresentanteInfoPedido();

        if (response && response.success === false) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.title || 'Representante não autorizado',
              text: response.message || 'Você não tem permissão para acessar este representante.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          this.formInfoPedido.dataCapaPedido.representanteid = '';
          this.formInfoPedido.dataCapaPedido.representantenome = '';
          this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
          return;
        }

        if (response && response.length > 0) {
          const representante = response[0];

          this.formInfoPedido.dataCapaPedido.representantenome = representante.representantenome;
          this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representante);

          await slsClienteService.listarClienteInfoPedido({
            representanteid: this.formInfoPedido.dataCapaPedido.representanteid,
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Representante não encontrado',
              text: 'O representante informado não foi encontrado, por favor, verifique o código!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.representantenome = '';
        }
      } catch (error) {
        console.error('Erro ao buscar representante:', error);

        if (error.response && error.response.data) {
          const errorData = error.response.data;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: errorData.title || 'Erro ao buscar representante',
              text: errorData.message || 'Não foi possível buscar os dados do representante. Tente novamente.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao buscar representante',
              text: 'Não foi possível buscar os dados do representante. Tente novamente.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        }

        this.formInfoPedido.dataCapaPedido.representantenome = '';
      } finally {
        this.$store.commit('intensPedido/SET_IS_LOADING_CAPA_PEDIDO', false);
      }
    },
    async loadingClientes() {
      const representanteId = this.formInfoPedido.dataCapaPedido.representanteid;
      // const clientes = this.$store.getters['SLSCliente/clientes'];
      // const storedFilters = this.$store.getters['SLSCliente/filters'];

      // if (clientes && clientes.length > 0 && storedFilters.representanteid === representanteId) {
      //   console.log('Clientes já carregados para este representante, usando cache');
      //   return;
      // }

      await slsClienteService.listarClienteInfoPedido({
        representanteid: representanteId,
        perPage: 10,
      });
    },
    async onChagenCliente() {
      this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', true);
      this.$store.commit('intensPedido/SET_IS_LOADING', true);
      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      if (!this.formInfoPedido.dataCapaPedido.clienteiderp) {
        await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
        this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
        this.$store.commit('intensPedido/SET_IS_LOADING', false);
        return;
      }

      try {
        const representanteId = this.formInfoPedido.dataCapaPedido.representanteid;
        const clienteIdDigitado = this.formInfoPedido.dataCapaPedido.clienteiderp;
        const clienteIdDigitadoSemZeros = this.removeLeadingZeros(clienteIdDigitado);

        const clientesDoRepresentante = await slsClienteService.listarClienteInfoPedido({
          representanteid: representanteId,
          perPage: 10,
        });

        const clienteEncontrado = clientesDoRepresentante.find(
          (cliente) => this.removeLeadingZeros(cliente.clienteiderp) === clienteIdDigitadoSemZeros,
        );

        if (!clienteEncontrado) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Tente novamente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
          this.formInfoPedido.dataCapaPedido.clienteiderp = '';
          this.formInfoPedido.dataCapaPedido.cliente_nome = '';

          this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
          this.$store.commit('intensPedido/SET_IS_LOADING', false);
          return;
        }

        const data = await slsClienteService.getInfoPedidoNovo(clienteEncontrado.clienteiderp);
        console.log('Dados do cliente recebidos:', data);

        if (!data) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'O cliente informado não foi encontrado, por favor, verifique o código informado!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const representanteIdSelecionado = this.formInfoPedido.dataCapaPedido.representanteid;
        const representanteIdCliente = data.representante?.representanteid;

        if (representanteIdSelecionado
          && representanteIdCliente
          && representanteIdCliente !== representanteIdSelecionado) {
          await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Tente novamente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          this.formInfoPedido.dataCapaPedido.clienteiderp = '';
          this.formInfoPedido.dataCapaPedido.cliente_nome = '';
          return;
        }

        this.dadosCliente = data;
        this.$store.commit('intensPedido/SET_IFO_CLIENTE', data);

        if (data.enderecoEntrega) {
          this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
            clienteendereco: data.enderecoEntrega.clienteendereco || '',
            clienteendereconumero: data.enderecoEntrega.clienteendereconumero || '',
            clienteenderecocomplemento: data.enderecoEntrega.clienteenderecocomplemento || '',
            clienteenderecobairro: data.enderecoEntrega.clienteenderecobairro || '',
            clienteenderecocidade: data.enderecoEntrega.clienteenderecocidade || '',
            clienteenderecocep: data.enderecoEntrega.clienteenderecocep || '',
            ufid: data.enderecoEntrega.ufid || '',
            clienteid: data.cliente?.clienteid || '',
            tipoenderecoid: data.enderecoEntrega.tipoenderecoid || '',
            dataPrevistaEntrega: data.enderecoEntrega.dataPrevistaEntrega || this.calcularDataEntregaPadrao(),
          });
        } else if (data.cliente) {
          this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
            clienteendereco: data.cliente.clienteendereco || '',
            clienteendereconumero: data.cliente.clienteendereconumero || '',
            clienteenderecocomplemento: data.cliente.clienteenderecocomplemento || '',
            clienteenderecobairro: data.cliente.clienteenderecobairro || '',
            clienteenderecocidade: data.cliente.clienteenderecocidade || '',
            clienteenderecocep: data.cliente.clienteenderecocep || '',
            ufid: data.cliente.ufid || '',
            clienteid: data.cliente.clienteid || '',
            tipoenderecoid: 1,
            dataPrevistaEntrega: this.calcularDataEntregaPadrao(),
          });
        }

        // Merge não destrutivo do formInfoPedido existente
        const currentForm = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
        const mergedForm = {
          ...currentForm,
          cliente: {
            ...(currentForm.cliente || {}),
            clienteid: data.cliente.clienteid,
            clienteiderp: data.cliente.clienteiderp,
            clienterazaosocial: data.cliente.clienterazaosocial,
          },
          representante: {
            ...(currentForm.representante || {}),
            representanteid: this.formInfoPedido.dataCapaPedido.representanteid,
            representantenome: this.formInfoPedido.dataCapaPedido.representantenome,
          },
        };
        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', mergedForm);

        if (Array.isArray(data.optionsCondPagtoCliente) && data.optionsCondPagtoCliente.length === 1) {
          this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', data.optionsCondPagtoCliente);
          this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', data.optionsCondPagtoCliente);
        }

        if (Array.isArray(data.optionsTabelaPrecoCliente) && data.optionsTabelaPrecoCliente.length === 1) {
          const unicaTabelaPreco = data.optionsTabelaPrecoCliente[0];

          this.formInfoPedido.dataCapaPedido.tabelaprecoid = unicaTabelaPreco.tabelapreco_id;
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = unicaTabelaPreco.tabelapreco_descricao;
        }

        if (data.cliente?.clienteid) {
          try {
            const condPagamentos = await slsCondicaoPagamentoService.GetCondPagtoByClienteId(data.cliente.clienteid);
            if (!Array.isArray(condPagamentos) || condPagamentos.length === 0) {
              console.log('Cliente não possui condições de pagamento');
              this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
              this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Aviso',
                  text: 'Não foram encontradas condições de pagamento para este cliente',
                  icon: 'AlertTriangleIcon',
                  variant: 'warning',
                },
              });
            }
          } catch (error) {
            console.warn('Erro ao buscar condições de pagamento:', error);
            this.formInfoPedido.dataCapaPedido.condicaopagamentoid = '';
            this.formInfoPedido.dataCapaPedido.condicaopagamentodescricao = '';
          }
        }

        if (data.cliente?.clienteiderp) {
          try {
            const tabelasPreco = await slsTabelapreco.getTabelaPrecoByClienteIdERP(data.cliente.clienteiderp);
            if (!Array.isArray(tabelasPreco) || tabelasPreco.length === 0) {
              console.log('Cliente não possui tabelas de preço');
              this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
              this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Aviso',
                  text: 'Não foram encontradas tabelas de preço para este cliente',
                  icon: 'AlertTriangleIcon',
                  variant: 'warning',
                },
              });
            }
          } catch (error) {
            console.warn('Erro ao buscar tabela de preço:', error);
            this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
            this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
          }
        }

        const filtrosPic = {};

        if (data.cliente?.clienteid) filtrosPic.clienteid = data.cliente.clienteid;
        if (data.estabelecimento?.estabelecimentoid) filtrosPic.estabelecimentoid = data.estabelecimento.estabelecimentoid;
        if (data.tabelaPreco?.tabelapreco_id) filtrosPic.tabelaprecoId = data.tabelaPreco.tabelapreco_id;
        if (data.condicaoPagamento?.condicaopagamentoid) filtrosPic.condicaopagamentoid = data.condicaoPagamento.condicaopagamentoid;

        if (Object.keys(filtrosPic).length > 0) {
          this.$store.commit('PicStore/SET_FILTERS', filtrosPic);
          await picService.getPicPedidos();
        }
      } catch (error) {
        console.error('Erro ao buscar cliente:', error);
        this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
        this.$store.commit('intensPedido/SET_IS_LOADING', false);

        // await Swal.fire({
        //   title: 'Erro ao buscar cliente',
        //   text: 'Não foi possível buscar os dados do cliente. Tente novamente.',
        //   icon: 'error',
        //   confirmButtonText: 'OK'
        // });
      } finally {
        this.$store.commit('intensPedido/SET_IS_LOADING_IFO_CLIENTE', false);
        this.$store.commit('intensPedido/SET_IS_LOADING', false);
      }
    },
    async onChageCodigoTabelaPreco(event) {
      const codTabelaPreco = typeof event === 'object' && event.target
        ? event.target.value
        : this.formInfoPedido.dataCapaPedido.tabelaprecoid;

      this.$store.commit('PicStore/SET_FILTERS_TABELAPRECO_ID', codTabelaPreco);

      if (!codTabelaPreco || !codTabelaPreco.length) {
        this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
        this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
        return;
      }

      this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', true);

      try {
        const clienteIdERP = this.formInfoPedido.dataCapaPedido.clienteiderp;
        if (!clienteIdERP) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não selecionado',
              text: 'Selecione um cliente antes de definir a tabela de preço.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
          return;
        }

        const response = await slsTabelapreco.getTabelaPrecoByClienteIdERP(clienteIdERP);

        if (!Array.isArray(response) || response.length === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sem tabelas de preço',
              text: 'Não foram encontradas tabelas de preço para este cliente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
          return;
        }

        const currentTabelaPreco = this.$store.getters['SLSTabelapreco/tabelaprecos'].find(
          (tabelaPreco) => String(tabelaPreco.tabelapreco_id).toUpperCase() === String(codTabelaPreco).toUpperCase(),
        );

        if (!currentTabelaPreco) {
          this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
          this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Tabela de preço não encontrada',
              text: 'A tabela de preço informada não foi encontrada, por favor, verifique o código informado!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        this.formInfoPedido.dataCapaPedido.tabelaprecoid = currentTabelaPreco.tabelapreco_id;
        this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = currentTabelaPreco.tabelapreco_descricao;

        if (this.formInfoPedido.dataCapaPedido.clienteiderp) {
          const filtrosPic = {};

          if (this.dadosCliente.cliente?.clienteid) filtrosPic.clienteid = this.dadosCliente.cliente.clienteid;
          if (this.dadosCliente.estabelecimento?.estabelecimentoid) filtrosPic.estabelecimentoid = this.dadosCliente.estabelecimento.estabelecimentoid;
          if (currentTabelaPreco?.tabelapreco_id) filtrosPic.tabelaprecoId = currentTabelaPreco.tabelapreco_id;
          if (this.formInfoPedido.dataCapaPedido.condicaopagamentoid) filtrosPic.condicaopagamentoid = this.formInfoPedido.dataCapaPedido.condicaopagamentoid;

          if (Object.keys(filtrosPic).length > 0) {
            this.$store.commit('PicStore/SET_FILTERS', filtrosPic);
            await picService.getPicPedidos();
          }
        }
      } catch (error) {
        console.error('Erro ao buscar tabela de preço:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao buscar a tabela de preço. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        this.formInfoPedido.dataCapaPedido.tabelaprecoid = '';
        this.formInfoPedido.dataCapaPedido.tabelapreco_descricao = '';
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', false);
      }
    },
    async removeItem(item) {
      await this.removeItemListTabelaItens(item.index);

      this.$root.$emit('item:removed', {
        referencia: item.item.CodReferencia || item.item.referencia,
      });

      this.$root.$emit('modal:sync-items');
    },
    async removeSubItem(row, subIndex) {
      const subItem = row.item.itens[subIndex];

      row.item.itens.splice(subIndex, 1);

      row.item.Qtde = row.item.itens.reduce((sum, item) => sum + item.pedidoItemQuantidade, 0);
      row.item.ValorTotal = row.item.itens.reduce((sum, item) => sum + (item.pedidoItemQuantidade * item.precoUnitario), 0);

      if (row.item.itens.length === 0) {
        await this.removeItem({ index: row.index });
      } else {
        this.$store.commit('intensPedido/UPDATE_TABELA_ITEM', {
          index: row.index,
          item: row.item,
        });

        this.$root.$emit('subitem:removed', {
          referencia: row.item.CodReferencia || row.item.referencia,
          item_id: subItem.itemId,
          des_cor: subItem.des_cor,
          tamanho: subItem.desc_tamanho,
        });
      }
    },
    async onSubmitRascunho() {
      this.show = true;

      const infoFormData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];

      if (!infoFormData.cliente || !infoFormData.cliente.clienteid) {
        this.show = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Cliente não identificado. Por favor, selecione um cliente válido.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      const processarDataEntrega = () => {
        const dataPrevistaEntrega = this.formInfoPedido.enderecoEntrega.dataPrevistaEntrega
          || infoFormData.enderecoEntrega?.dataPrevistaEntrega;

        if (!dataPrevistaEntrega) {
          return this.calcularDataEntregaPadrao();
        }

        // Converte para formato ISO se estiver no formato DD/MM/YYYY
        if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('/')) {
          const [dia, mes, ano] = dataPrevistaEntrega.split('/');
          return `${ano}-${mes}-${dia}`;
        }

        // Se já estiver no formato ISO (YYYY-MM-DD), retorna como está
        if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('-')) {
          return dataPrevistaEntrega;
        }

        return this.calcularDataEntregaPadrao();
      };

      const dataEntregaProcessada = processarDataEntrega();

      const tipopedidoid = infoFormData.tipoPedido?.tipopedidoid
        || infoFormData.tipoPedidoCliente?.tipopedidoid
        || this.getFormData.dataCapaPedido.tipopedidoid
        || 1;

      const payload = {
        clienteid: infoFormData.cliente.clienteid,
        tipopedidoid,
        condicaopagamentoid: infoFormData.condicaoPagamento?.condicaopagamentoid || this.getFormData.dataCapaPedido.condicaopagamentoid,
        // naturezaoperacaoid: infoFormData.cliente.naturezaoperacaoid || this.getFormData.dataCapaPedido.naturezaoperacaoid,
        naturezaoperacaoid: this.getListTabelaItens[0].itens[0].naturezaoperacaoidimposto,
        tabelaprecoid: infoFormData.tabelaPreco?.tabelapreco_id || this.getFormData.dataCapaPedido.tabelaprecoid,
        pedidoobservacoes: infoFormData.observacao || this.getFormData.dataCapaPedido.observacoes,
        pedidourgente: false,
        // pedidodataentrega: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidodataentrega: dataEntregaProcessada,
        // pedidodataentregaprevista: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidodataentregaprevista: dataEntregaProcessada,
        pedidovalortotal: this.getTotalPedido,
        tipoenderecoid: infoFormData.enderecoEntrega?.tipoenderecoid || this.getFormData.enderecoEntrega.tipoenderecoid || 1,
        pedidooccliente: infoFormData.numeroPedidoOrderCompra || this.getFormData.dataCapaPedido.nr_oc || '',
        pedidoconsumidorfinal: true,
        pedidoprioridade: infoFormData.prioridadesPedido || this.getFormData.dataCapaPedido.prioridade_pedido || 1,
        canalvendaid: infoFormData.cliente.canal_venda_id || this.getFormData.dataCapaPedido.canalvendaid || '',
        cod_priori: infoFormData.prioridadesPedido || this.getFormData.dataCapaPedido.prioridade_pedido || 1,
        representanteid: infoFormData.representante?.representanteid || this.getFormData.dataCapaPedido.representanteid,
        estabelecimentoid: infoFormData.estabelecimento?.estabelecimentoid || this.getFormData.dataCapaPedido.estabelecimentoid,
        itemsPedido: this.getListTabelaItens.map((item) => ({
          ...item,
          PrecoComImposto: item.PrecoComImposto || item.precoComImposto || 0,
          BaseIcms: item.BaseIcms || item.baseIcms || item.base_icms || 0,
          ValorIcms: item.ValorIcms || item.valorIcms || item.valor_icms || 0,
          itens: item.itens.map((subItem) => ({
            ...subItem,
            precoComImposto: subItem.precoComImposto || subItem.preco_com_imposto || 0,
            baseIcms: subItem.baseIcms || subItem.base_icms || 0,
            valorIcms: subItem.valorIcms || subItem.valor_icms || 0,
            valorTotalComImposto: subItem.valorTotalComImposto || 0,
            naturezaoperacaoidimposto: subItem.naturezaoperacaoidimposto || subItem.natureza_operacao_id_imposto || 0,
          })),
        })),
      };

      console.log('Payload de envio do pedido:', payload);

      try {
        const response = await slsPedidosService.finalizarRascunhoOperacao(payload);
        try {
          const draftId = String(response?.data?.data?.pedidoid || Date.now());
          const draft = {
            id: draftId,
            createdAt: Date.now(),
            updatedAt: Date.now(),
            infoPedidoSnapshot: infoFormData,
            itens: this.getListTabelaItens,
            total: this.getTotalPedido,
          };

          const indexKey = 'pedido_drafts_index';
          const currentIndex = JSON.parse(localStorage.getItem(indexKey) || '[]');
          const withoutThis = currentIndex.filter((d) => String(d.id) !== draftId);
          const meta = {
            id: draftId,
            createdAt: draft.createdAt,
            updatedAt: draft.updatedAt,
            cliente: {
              id: infoFormData?.cliente?.clienteid,
              nome: infoFormData?.cliente?.clienterazaosocial,
              iderp: infoFormData?.cliente?.clienteiderp,
            },
            representante: {
              id: infoFormData?.representante?.representanteid,
              nome: infoFormData?.representante?.representantenome,
            },
            tabelaprecoid: infoFormData?.tabelaPreco?.tabelapreco_id || null,
            condicaopagamentoid: infoFormData?.condicaoPagamento?.condicaopagamentoid || null,
            total: this.getTotalPedido,
          };

          localStorage.setItem(`pedido_draft_${draftId}`, JSON.stringify(draft));
          localStorage.setItem(indexKey, JSON.stringify([...withoutThis, meta]));
          localStorage.setItem('activeDraftId', draftId);
        } catch (e) {
          console.warn('Falha ao persistir snapshot do rascunho localmente:', e);
        }

        this.show = false;
        Swal.fire({
          title: 'Rascunho Salvo com Sucesso!',
          html: `Seu rascunho foi salvo com sucesso! Número do Rascunho: <strong>#${response.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          // this.clearCreatePedido();
          this.$store.dispatch('intensPedido/clearPedidoData');
          this.$router.push({ name: 'pedidos-vendas' });
        });
      } catch (error) {
        this.show = false;
        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message || 'Ocorreu um erro ao salvar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } finally {
        this.show = false;
      }
    },
    getActiveDraftId() {
      try {
        return localStorage.getItem('activeDraftId') || null;
      } catch (e) {
        return null;
      }
    },
    shouldRestoreDraft() {
      const query = this.$route?.query || {};
      const params = this.$route?.params || {};

      const restoreFlag = String(query.restoreDraft || '').toLowerCase();
      const hasRestoreFlag = restoreFlag === '1' || restoreFlag === 'true';
      const hasDraftId = !!(query.draftId || params.draftId);

      return hasRestoreFlag || hasDraftId;
    },
    async loadActiveDraftIfAny() {
      if (!this.shouldRestoreDraft()) return;

      const activeId = this.getActiveDraftId();
      if (!activeId) return;
      try {
        const raw = localStorage.getItem(`pedido_draft_${activeId}`);
        if (!raw) return;
        const draft = JSON.parse(raw);
        if (draft && Array.isArray(draft.itens)) {
          await this.$store.dispatch('intensPedido/setListTabelaItens', draft.itens);
        }
        if (draft && draft.infoPedidoSnapshot) {
          this.$root.$emit('info-pedido:updated', draft.infoPedidoSnapshot);
        }
      } catch (e) {
        console.warn('Não foi possível restaurar o rascunho ativo:', e);
      }
    },
    async onSubmit() {
      this.show = true;

      const infoFormData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];

      if (!infoFormData.cliente || !infoFormData.cliente.clienteid) {
        this.show = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Cliente não identificado. Por favor, selecione um cliente válido.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      const processarDataEntrega = () => {
        const dataPrevistaEntrega = this.formInfoPedido.enderecoEntrega.dataPrevistaEntrega
          || infoFormData.enderecoEntrega?.dataPrevistaEntrega;

        if (!dataPrevistaEntrega) {
          return this.calcularDataEntregaPadrao();
        }

        // Converte para formato ISO se estiver no formato DD/MM/YYYY
        if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('/')) {
          const [dia, mes, ano] = dataPrevistaEntrega.split('/');
          return `${ano}-${mes}-${dia}`;
        }

        // Se já estiver no formato ISO (YYYY-MM-DD), retorna como está
        if (typeof dataPrevistaEntrega === 'string' && dataPrevistaEntrega.includes('-')) {
          return dataPrevistaEntrega;
        }

        return this.calcularDataEntregaPadrao();
      };

      const dataEntregaProcessada = processarDataEntrega();

      const tipopedidoid = infoFormData.tipoPedido?.tipopedidoid
        || infoFormData.tipoPedidoCliente?.tipopedidoid
        || this.getFormData.dataCapaPedido.tipopedidoid
        || 1;

      const payload = {
        clienteid: infoFormData.cliente.clienteid,
        tipopedidoid,
        condicaopagamentoid: infoFormData.condicaoPagamento?.condicaopagamentoid || this.getFormData.dataCapaPedido.condicaopagamentoid,
        // naturezaoperacaoid: infoFormData.cliente.naturezaoperacaoid || this.getFormData.dataCapaPedido.naturezaoperacaoid,
        naturezaoperacaoid: this.getListTabelaItens[0].itens[0].naturezaoperacaoidimposto,
        tabelaprecoid: infoFormData.tabelaPreco?.tabelapreco_id || this.getFormData.dataCapaPedido.tabelaprecoid,
        pedidoobservacoes: infoFormData.observacao || this.getFormData.dataCapaPedido.observacoes,
        pedidourgente: false,
        // pedidodataentrega: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidodataentrega: dataEntregaProcessada,
        // pedidodataentregaprevista: infoFormData.enderecoEntrega?.dataPrevistaEntrega || this.getFormData.enderecoEntrega.dataPrevistaEntrega,
        pedidodataentregaprevista: dataEntregaProcessada,
        pedidovalortotal: this.getTotalPedido,
        tipoenderecoid: infoFormData.enderecoEntrega?.tipoenderecoid || this.getFormData.enderecoEntrega.tipoenderecoid || 1,
        pedidooccliente: infoFormData.numeroPedidoOrderCompra || this.getFormData.dataCapaPedido.nr_oc || '',
        pedidoconsumidorfinal: true,
        pedidoprioridade: infoFormData.prioridadesPedido || this.getFormData.dataCapaPedido.prioridade_pedido || 1,
        canalvendaid: infoFormData.canalVenda.canal_venda_id || infoFormData.cliente.canalvendaid || '',
        cod_priori: infoFormData.prioridadesPedido || this.getFormData.dataCapaPedido.prioridade_pedido || 1,
        representanteid: infoFormData.representante?.representanteid || this.getFormData.dataCapaPedido.representanteid,
        estabelecimentoid: infoFormData.estabelecimento?.estabelecimentoid || this.getFormData.dataCapaPedido.estabelecimentoid,
        itemsPedido: this.getListTabelaItens.map((item) => ({
          ...item,
          PrecoComImposto: item.PrecoComImposto || item.precoComImposto || 0,
          BaseIcms: item.BaseIcms || item.baseIcms || item.base_icms || 0,
          ValorIcms: item.ValorIcms || item.valorIcms || item.valor_icms || 0,
          itens: item.itens.map((subItem) => ({
            ...subItem,
            precoComImposto: subItem.precoComImposto || subItem.preco_com_imposto || 0,
            baseIcms: subItem.baseIcms || subItem.base_icms || 0,
            valorIcms: subItem.valorIcms || subItem.valor_icms || 0,
            valorTotalComImposto: subItem.valorTotalComImposto || 0,
            naturezaoperacaoidimposto: subItem.naturezaoperacaoidimposto || subItem.natureza_operacao_id_imposto || 0,
          })),
        })),
      };

      console.log('Payload de envio do pedido:', payload);

      try {
        const response = await slsPedidosService.finalizarPedidoOperacao(payload);
        this.show = false;
        // Aviso: integração com TOTVS pausada para testes
        const totvsFlag = await getParametro('INTEGRACAO_TOTVS');
        if (String(totvsFlag) === '0' && this.$toast) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'A integração com o TOTVS está pausada para período de testes.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }
        Swal.fire({
          title: 'Pedido salvo com sucesso!',
          html: `Seu pedido foi finalizado com sucesso! Número do Pedido: <strong>#${response.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          // this.clearCreatePedido();
          try {
            const activeId = this.getActiveDraftId();
            if (activeId) {
              localStorage.removeItem(`pedido_draft_${activeId}`);
              const indexKey = 'pedido_drafts_index';
              const currentIndex = JSON.parse(localStorage.getItem(indexKey) || '[]');
              const newIndex = currentIndex.filter((d) => String(d.id) !== String(activeId));
              localStorage.setItem(indexKey, JSON.stringify(newIndex));
              localStorage.removeItem('activeDraftId');
            }
          } catch (e) {
            console.warn('Falha ao limpar rascunho ativo após finalizar:', e);
          }
          this.$store.dispatch('intensPedido/clearPedidoData');
          this.$router.push({ name: 'pedidos-vendas' });
        });
      } catch (error) {
        this.show = false;
        Swal.fire({
          title: error.response?.data?.title || 'Erro',
          text: error.response?.data?.message || 'Ocorreu um erro ao salvar o pedido',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } finally {
        this.show = false;
      }
    },
    async voltar() {
      this.clearCreatePedido();
      this.$router.push({ name: 'pedidos-vendas' });
    },
    async editarItem(item) {
      console.log('item', item);
      await this.$refs['editar-itens-pedido'].show({
        index: item.index,
        item: item.item.editar,
        subItens: item.item.itens,
      });
    },
  },
  computed: {
    dataEntregaPadrao() {
      const date = new Date();
      date.setDate(date.getDate() + 7);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    isInfoPedidoBloqueado() {
      return this.getListTabelaItens.length > 0;
    },
    isClienteFinal() {
      const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
      return perfilLogado && perfilLogado.perfil_acesso_nome === 'ClienteFinal';
    },
    isTabItensDisabled() {
      const info = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      return !(
        info?.representante?.representanteid
        && info?.cliente?.clienteiderp
        && info?.tabelaPreco?.tabelapreco_id
        && info?.estabelecimento?.estabelecimentoid
      );
    },
    clienteIdErpSemZeros: {
      get() {
        if (!this.formInfoPedido.dataCapaPedido.clienteiderp) return '';
        return this.removeLeadingZeros(this.formInfoPedido.dataCapaPedido.clienteiderp);
      },
      set(value) {
        this.formInfoPedido.dataCapaPedido.clienteiderp = value;
      },
    },
    ...mapGetters('SLSRepresentante', {
      representante: 'selectedRepresentante',
    }),
    pedidoMinimo() {
      const valorMinimo = parseFloat(this.dadosCliente.valorMinimoPedido || 0);
      const totalAtual = this.getTotalPedido;

      // console.log('Validação pedido mínimo:', {
      //   totalAtual,
      //   valorMinimo,
      //   clienteId: this.dadosCliente.cliente?.clienteid || 'não definido',
      // });

      return totalAtual >= valorMinimo;
    },
    ...mapGetters('InfoPedido', {
      getFormInfoPedido: ' GET_FORM_INFO_PEDIDO',
      getLoadingRepresentante: 'GET_LOADING_REPRESENTANTE',
      getLoadingCondPagamento: 'GET_LOADING_COND_PAGAMENTO',
      getOptionsCondPagamento: 'GET_OPTIONS_CONDICAO_PAGAMENTO',
    }),
    ...mapGetters('intensPedido', {
      getFormData: 'getFormData',
      getIsLoadingCapaPedido: 'getIsLoadingCapaPedido',
      getIsLoadingCliente: 'getIsLoadingCliente',
      getListTabelaItens: 'getlistarTabelaItens',
      getTotalPedido: 'getTotalPedido',
      getItemsPedidosArray: 'getItemsPedidosArray',
    }),
    ...mapGetters('PicStore', {
      loadingPic: 'GET_LOADING',
      IS_EXIST_PIC: 'IS_EXIST_PIC',
      picSelected: 'GET_PIC_SELECTED_OPERACAO',
    }),
    isRepresentanteDisabled() {
      return this.isClienteFinal && this.representantesCount === 1;
    },
    isClienteDisabled() {
      return this.isClienteFinal && this.clientesCount === 1
        || this.formInfoPedido.dataCapaPedido.representantenome === '';
    },
    disabledInputTabelaPreco() {
      const optionsTabelaPreco = this.$store.getters['InfoPedido/GET_OPTIONS_TABELA_PRECO'] || [];
      const tabelasPrecoSLS = this.$store.getters['SLSTabelapreco/tabelaprecos'] || [];

      const opcoes = optionsTabelaPreco.length > 0 ? optionsTabelaPreco : tabelasPrecoSLS;
      return opcoes.length === 1 || this.formInfoPedido.dataCapaPedido.clienteiderp === '';
    },
    disabledInputCondPagamento() {
      const infoPedido = this.$store.getters['InfoPedido/GET_OPTIONS_CONDICAO_PAGAMENTO'] || [];
      const condPagamentos = this.$store.getters['SLSCondicaoPagamento/GET_COND_PAGTOS'] || [];

      const opcoes = infoPedido.length > 0 ? infoPedido : condPagamentos;
      return opcoes.length === 1 || this.formInfoPedido.dataCapaPedido.clienteiderp === '';
    },
    formInfoPedido: {
      get() {
        return this.getFormData;
      },
      set(value) {
        this.$store.commit('intensPedido/SET_CAPA_PEDIDO', value);
      },
    },
  },
  async mounted() {
    this.verificarPerfilUsuario();
    this.clearCreatePedido();
    await slsEsPrioriService.selectPrioridadePedido();

    this.$watch(
      () => this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'],
      (newFormData) => {
        if (newFormData.cliente && newFormData.cliente.clienteid) {
          this.dadosCliente = {
            ...this.dadosCliente,
            cliente: newFormData.cliente,
            estabelecimento: newFormData.estabelecimento,
            tabelaPreco: newFormData.tabelaPreco,
            condicaoPagamento: newFormData.condicaoPagamento,
            enderecoEntrega: newFormData.enderecoEntrega,
            valorMinimoPedido: newFormData.valorMinimoPedido || 0,
          };

          this.$store.commit('intensPedido/SET_IFO_CLIENTE', this.dadosCliente);

          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.formInfoPedido.dataCapaPedido,
            clienteid: newFormData.cliente.clienteid,
            clienteiderp: newFormData.cliente.clienteiderp,
            cliente_nome: newFormData.cliente.clienterazaosocial,
            clientenomeabreviado: newFormData.cliente.clientenomeabreviado,
            clienteisentoie: newFormData.cliente.clienteisentoie,
            condicaopagamentoid: newFormData.condicaoPagamento?.condicaopagamentoid || '',
            condicaopagamentodescricao: newFormData.condicaoPagamento?.condicaopagamentodescricao || '',
            tabelaprecoid: newFormData.tabelaPreco?.tabelapreco_id || '',
            tabelapreco_descricao: newFormData.tabelaPreco?.tabelapreco_descricao || '',
            naturezaoperacaoid: newFormData.cliente?.naturezaoperacaoid || '',
            canalvendaid: newFormData.cliente?.canal_venda_id || '',
            estabelecimentoid: newFormData.estabelecimento?.estabelecimentoid || '',
            estabelecimentorazaosocial: newFormData.estabelecimento?.estabelecimentorazaosocial || '',
          });

          if (newFormData.enderecoEntrega) {
            this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
              ...newFormData.enderecoEntrega,
              clienteid: newFormData.cliente.clienteid,
            });
          }

          console.log('Dados do cliente atualizados do InfoPedido:', this.dadosCliente);
          console.log('Valor mínimo do pedido:', this.dadosCliente.valorMinimoPedido);
        }
      },
      { deep: true },
    );

    this.$root.$on('representante:changed', async (representanteId) => {
      console.log('Representante alterado:', representanteId);

      this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
        ...this.formInfoPedido.dataCapaPedido,
        clienteiderp: '',
        cliente_nome: '',
        clientenomeabreviado: '',
        clienteisentoie: '',
        condicaopagamentoid: '',
        condicaopagamentodescricao: '',
        tabelaprecoid: '',
        tabelapreco_descricao: '',
        naturezaoperacaoid: '',
        naturezaoperacaodescricao: '',
        canalvendaid: '',
        canal_venda_descricao: '',
        estabelecimentoid: '',
        estabelecimentorazaosocial: '',
      });

      this.$store.commit('InfoPedido/SET_OPTIONS_TABELA_PRECO', []);
      this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', []);
      this.$store.commit('SLSCondicaoPagamento/SET_CURRENT_COND_PAGTO', []);
      this.$store.commit('PicStore/RESET_PIC_SELECTION');
    });

    this.$root.$on('condpagto:selected', (condPagto) => {
      this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
        ...this.formInfoPedido.dataCapaPedido,
        condicaopagamentoid: condPagto.condicaopagamentoid,
        condicaopagamentodescricao: condPagto.condicaopagamentodescricao,
      });

      this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', condPagto.condicaopagamentoid);
      picService.getPicPedidos();
    });

    this.$root.$on('cliente:selected-from-modal', (clienteData) => {
      this.dadosCliente = clienteData;
      console.log('Dados do cliente atualizados do modal:', this.dadosCliente);
    });

    if (!this.formInfoPedido.enderecoEntrega.dataPrevistaEntrega) {
      const defaultDate = new Date();
      defaultDate.setDate(defaultDate.getDate() + 7);

      const day = String(defaultDate.getDate()).padStart(2, '0');
      const month = String(defaultDate.getMonth() + 1).padStart(2, '0');
      const year = defaultDate.getFullYear();

      const formattedDate = `${day}/${month}/${year}`;

      this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
        ...this.formInfoPedido.enderecoEntrega,
        dataPrevistaEntrega: formattedDate,
      });
    }

    // Restaurar rascunho ativo (se houver)
    await this.loadActiveDraftIfAny();
  },
  beforeDestroy() {
    this.$root.$off('condpagto:selected');
    this.$root.$off('cliente:selected-from-modal');

    // console.log('Componente está prestes a ser desmontado');

    this.$store.commit('PicStore/SET_PIC', {
      pic_genericas: [],
      pic_cliente: [],
    });
  },
};
</script>

<style lang="scss" scoped>
.quantity-control {
  display: flex;
  align-items: center;
  justify-content: center;

  .btn-quantity {
    padding: 0.15rem 0.4rem;
    line-height: 1;
  }

  .quantity-value {
    min-width: 30px;
    text-align: center;
    font-weight: 600;
  }
}
</style>
